// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const IoTIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="IoTIcon" ref={forwardedRef} {...props}>
      <path d="M15 12.037h-.9v2.58h1.56a1.5 1.5 0 1 1 0 1.25h-2.81v-3.83h-2.224v4.099a1.5 1.5 0 1 1-1.25 0v-4.1H7.15v3.832H4.34a1.5 1.5 0 1 1 0-1.25H5.9v-2.583a4 4 0 0 1-3.9-4c0-2.21 1.905-4.257 4.303-4 .653-1.37 2.079-2.5 3.697-2.5 2.03 0 3.434 1.132 4.157 3.424 1.933 0 3.844 1.643 3.844 3.576 0 1.763-1.304 3.259-3 3.502M7.008 5.542c-2.182-.45-3.506 1.111-3.506 2.493a2.5 2.5 0 0 0 2.5 2.5h9c.968-.138 1.5-.994 1.5-2 .06-.378-.036-2.314-3.598-2.314C12.421 3.222 10.728 3.036 10 3.036c-1.02 0-2.113.914-2.993 2.506" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const IoTIcon = /* @__PURE__ */ Object.assign(IoTIconComponent, {
  displayName: 'IoTIcon',
});
